<template>
    <div class="folder-cover" :class="{zero: fileFolderList.length === 0}">
        <div v-for="[folder, fileList, fileLength] in showList"
            :key="folder"
            class="folder">
            <div class="folder-title"> 
                {{ getFolderName(folder) }}
                <span v-if="folder !== 'other'" class="folder-count">
                    ({{ fileLength }} file{{ fileLength === 1 ? '' : 's'}})
                </span>
                 
            </div>
            <el-table
                :data="fileList"
                :show-header="false"
                empty-text="No Files added yet"
                cell-class-name="record-cell"
                class="record-table"
                style="width: 100%">
                <el-table-column width="120">
                    <template slot-scope="scope">
                        <div class="attach-file" @click="startDownloadFile(scope.row)" :class="{downloading: downloadingMap[scope.row.id]}">
                            <DownloadFileIcon></DownloadFileIcon>
                            <span class="attach-category">{{ getCategoryName(scope.row.category_id) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200">
                    <template slot-scope="scope">
                        <div class="attach-name">
                            {{ scope.row.name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column >
                    <template slot-scope="scope">
                        <div class="attach-comment" v-if="!scope.row.comment && getUserType !== 'observer'">
                            <el-button size="small" @click="openCommentDialog(scope.row)">
                                <div class="button-set">
                                    <i class="el-icon-plus"></i>
                                    Add Comments
                                </div>
                            </el-button>
                        </div>
                        <div class="attach-comment" v-else>
                            <p>
                                {{ scope.row.comment }}
                                <span
                                    class="edited-by"
                                    v-if="scope.row.modified_by && getUserType !== 'observer'"
                                    @click="getRevisionHistory('file', scope.row.id)">
                                    (Edited by {{ scope.row.modified_name ||  getUploader(scope.row.modified_by)}})
                                </span>
                            </p>
                            <el-button @click="openCommentDialog(scope.row)" v-if="getUserType !== 'observer'">
                                <div class="button-set" >
                                    <EditIcon height="11"></EditIcon>
                                    Edit Comments
                                </div>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200">
                    <template slot-scope="scope" >
                        <div class="attach-date" v-if="getUploader(scope.row.uploaded_by) && getUserType !== 'observer'">
                            <span>
                                <i>Added by {{ getUploader(scope.row.uploaded_by) }}</i> - {{ formatDate(scope.row.created) }}
                                <br>
                            </span>
                            <span v-if="scope.row.modified_time">
                                <i>Last updated</i> - {{ formatDate(scope.row.modified_time) }}
                            </span>
                        </div>
                        <div class="attach-date" v-if="getUserType === 'observer'">
                            <span v-if="scope.row.modified_time" class="observer">
                                Last updated {{ formatDate(scope.row.modified_time) }}
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <template v-if="fileLength > 3">
                <div class="show-more" @click="showMore(folder)" v-if="!isExpanded(folder, fileLength)">
                    Show More &nbsp; <i class="el-icon-arrow-down"></i>
                </div>
                <div class="show-more" @click="showLess(folder)" v-else>
                    Show less &nbsp; <i class="el-icon-arrow-up"></i>
                </div>
            </template>
            
        </div>
        <div class="zero-state" v-if="fileFolderList.length === 0">
            <span>No Files added yet</span> 
            <el-button @click="$emit('add-new')"> 
                <span class="button-central">
                    <i>&#43;</i> Add New
                </span>
                
            </el-button>
        </div>
        <el-dialog
          :visible.sync="showHistory"
          :append-to-body="true"
          class="send-now-modal record-history-dialog"
          @close="closeCommentDialog"
          :close-on-click-modal="false"
          width="70%">
          <div slot="title">Edit History</div>
          <div class="loading-content" v-if="loadHistory">
                <LoadSpinnerIcon type="primary"></LoadSpinnerIcon>
                Loading Revision History
          </div>
          <div v-else-if="historyObj">
            <div
                v-for="(history, index) in historyObj.history"
                :key="index"
                class="record-history-body">
                    <div class="history-header">
                        <ImgPlaceholderIcon></ImgPlaceholderIcon>
                        <span class="name">{{history.modified_name || history.created_name}}</span>
                        <div class="oval"></div>
                        <span class="date">{{formatDateTime(history.modified_time) || formatDateTime(history.created)}}</span>
                    </div>
                    <div class="history-comment">{{history.comment}}</div>
            </div>
          </div>
          <div v-else style="color:red">
              Sorry there was error getting revision history
          </div>
          <div class="footer">
            <el-button
                type="primary"
                size="small"
                class="send-button"
                @click="showHistory = false">
                    Close
            </el-button>
          </div>
        </el-dialog>
        <el-dialog
          :visible.sync="addEditComment"
          :append-to-body="true"
          class="send-now-modal record-dialog"
          :close-on-click-modal="false"
          @close="closeCommentDialog"
          v-if="addEditComment"
          width="30%">
          <div slot="title">
              {{ editObj.comment ? 'Edit' : 'Add' }} {{ getCategoryName(editObj.category_id) }} Comments
          </div>
          <div>
              <div class="display-row">
                  <div class="category-info">
                      <span class="category-name">{{ editObj.name }}</span>
                      <span class="time">{{ formatDateTime(editObj.created) }}</span>
                  </div>
                  <div class="attach-file">
                    <AttachFileIcon></AttachFileIcon>
                    {{ getCategoryName(editObj.category_id) }}
                  </div>
              </div>
              <div class="input-row">
                    <label>{{ editObj.comment ? 'Edit' : 'Add' }}  Comments</label>
                    <el-input
                        type="textarea"
                        :rows="3"
                        size="small"
                        :maxlength="5000"
                        placeholder="Please input"
                        v-model="comment">
                    </el-input>
                    <div class="character-left">
                        {{ 5000 -  comment.length }} characters left
                    </div>
                    <span class="error-text" v-if="comment === '' && showError">
                        Please enter details
                    </span>
              </div>
          </div>
          <div class="footer">
              <LoadingButton
                    type="primary"
                    size="small"
                    class="send-button"
                    @click="update"
                    :loading="updating"
                    :loaded="updated">
                Done
            </LoadingButton>
            <el-button type="text" size="small" class="cancel-button" @click="addEditComment = false">
                Cancel
            </el-button>
          </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import CardTable from '../component/table'
import LoadingButton from '@/module/component/LoadingButton.vue'
import AttachFileIcon from '../../icon/AttachFile'
import DownloadFileIcon from '../../icon/DownloadArrow.vue'
import EditIcon from '@/module/add/icons/Edit.vue'
import ImgPlaceholderIcon from '@/module/add/icons/ImgPlaceholder.vue'
import LoadSpinnerIcon from '@/module/component/icon/LoadSpinner'


export default {
    name: 'patient-file-card-table',
    extends: CardTable,

    data() {
        return {
            addEditComment: false,
            editObj: null,
            comment: '',
            updating: false,
            updated: false,
            folderShowMap: {},
            showError: false,
            historyObj: {},
            showHistory: false,
            loadHistory: false,
            downloadingMap: {}
        }
        
    },

    props: {
        patient: {
            type: Object,
            required: true
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateFile',
            'revisionHistory',
            'downloadFile'
        ]),
        getCategoryName(categoryId) {
            const category = this.patientFileCategories.find((category) => category.id === categoryId)
            if(category)
                return category.title
            return ''
        },
        getFolderName(folderId) {
            if(folderId === 'other')
                return 'Other Files'
            const folder = this.patientFolderCategories.find((category) => category.id === folderId)
            if(folder)
                return folder.title
            return ''
        },
        getUploader(uploaderId) {
            if(this.getUser && this.getUser.id === uploaderId)
                return this.getUser.name
            return null
        },
        openCommentDialog(editObj) {
            this.editObj = editObj
            this.comment = editObj.comment || ''
            this.addEditComment = true
        },
        closeCommentDialog() {
            this.editObj = null
            this.comment = ''
            this.updated = false
            this.addEditComment = false
        },
        update() {
             if(this.comment === '') {
                this.showError = true
                return
            }
            const updateObj = {
                comment: this.comment,
                modified_by: this.getUser.id,
                modified_time: Date.now()
            }
            this.updating = true
            this.updateFile({
                patient: this.patient.id,
                provider: this.patientProviderProfileList[0].provider,
                id: this.editObj.id,
                previousObj: this.editObj,
                updateObj
            }).then((response) => {
                this.updating = false
                this.updated = true
                this.closeCommentDialog()
            }).catch((error) => {
                this.updated = false
                this.updating = false
            })
        },
        showLess(folder) {
            this.folderShowMap[folder] = 3
        },
        showMore(folder) {
            if(this.folderShowMap[folder])
                Vue.set(this.folderShowMap, folder, this.folderShowMap[folder] + 10)
            else
                Vue.set(this.folderShowMap, folder, 13)
        },
        isExpanded(currFolder, fileLength) {
            if(this.folderShowMap[currFolder] && fileLength < this.folderShowMap[currFolder])
                return true
            return false
        },
        getRevisionHistory(type, id) {
            this.showHistory = true
            this.loadHistory = true
            this.revisionHistory({
                type,
                id,
                patient: this.patient.id,
                provider: this.patientProviderProfileList[0].provider,
            }).then((response) => {
                this.historyObj = response.revision
                this.loadHistory = false
            }).catch(() => this.loadHistory = false)
        },
        startDownloadFile(row) {
            if(this.downloadingMap[row.id])
                return
            Vue.set(this.downloadingMap, row.id, true)
            this.downloadingMap[row.id] = true
            this.downloadFile(row)
                .then(() => Vue.set(this.downloadingMap, row.id, false))
                .catch(() => Vue.set(this.downloadingMap, row.id, false))
        }
    },

    computed: {
        ...mapGetters('provider', [
            'getPatientFiles',
            'getPatientProviderProfileList'
        ]),
        ...mapGetters('user', [
            'getUser'
        ]),
        ...mapGetters(['getUserType']),
        fileFolderList() {
            try {
                let folderObj =  this.getPatientFiles(this.patient.id).reduce((acc, patientFile) => {
                    const folderId = patientFile.folder
                    if(folderId)
                        acc[folderId] = acc[folderId] ? [ ...acc[folderId], patientFile] : [patientFile]
                    else
                        acc['other'] = acc['other'] ? [ ...acc['other'], patientFile] : [patientFile]
                    return acc
                }, {})
                const sortFolderIds = (a, b) => {
                    const aIndex = this.patientFolderCategoriesIds.indexOf(a[0]) , 
                        bIndex =  this.patientFolderCategoriesIds.indexOf(b[0])
                    return aIndex - bIndex
                }
                let otherObj
                if(folderObj['other']) {
                    otherObj = [...folderObj['other']]
                    delete folderObj['other']
                    const sortedFolders = Object.entries(folderObj).sort(sortFolderIds)
                    return [ ...sortedFolders, [ 'other', otherObj]]
                }
                return Object.entries(folderObj).sort(sortFolderIds)

            } catch (error) {
                console.error(error)
                return []
            }
            
        },
        showList() {
            return this.fileFolderList.map(([folder, fileList]) => {
                const fileLength = fileList.length
                if(!this.folderShowMap[folder])
                    return [folder, fileList.slice(0, 3), fileLength]
                else if((this.folderShowMap[folder] && this.folderShowMap[folder] < fileList.length))
                    return [folder, fileList.slice(0, this.folderShowMap[folder]), fileLength]
                return [folder, fileList, fileLength]
            })
        },
        patientProviderProfileList() {
            return this.getPatientProviderProfileList(this.patient.id)
        },
        patientFileCategories() {
            if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
                return this.getContentKey('profile', this.patientProviderProfileList[0].profile, 'file_categories')
            return []
        },
        patientFolderCategories() {
            if(this.patientProviderProfileList && this.patientProviderProfileList.length == 1)
                return this.getContentKey('profile', this.patientProviderProfileList[0].profile, 'folder_categories')
            return []
        },
        patientFolderCategoriesIds() {
            return this.patientFolderCategories.map(({id}) => id)
        }
    },

    components: {
        AttachFileIcon,
        DownloadFileIcon,
        EditIcon,
        LoadingButton,
        ImgPlaceholderIcon,
        LoadSpinnerIcon
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';

.folder-cover {
    background-color: #dfecf9;
    padding-top: 16px;
    padding-bottom: 1px;
}
.folder-cover.zero {
    padding-top: 0;
}
.character-left {
    font-size: 12px;
    color: #999999;
    margin-top: 3px;
}
.zero-state {
    padding: 20px;
    font-size: 14px;
    color: #999999;
    display: flex;
    align-items: center;
    .el-button {
        // display: none;
        // border: none;
        background-color: #DFECF9;
        color: #2d3e4f;
        font-size: 12px;
        font-weight: 600;
        margin-left: 20px;
        height: 25px;
        padding: 0px 5px;
        align-items: center;
        line-height: 25px;
        .button-central {
            display: flex;
            align-items: center;
            padding: 0 5px;
            line-height: 24px;
            height: 25px;
        }
        i {
            font-style: normal;
            font-size: 20px;
            margin-right: 5px;
        }
    }
}
.folder {
    background-color: #ffffff;
    margin-bottom: 16px;
    margin-left: 12px;
    margin-right: 12px;
    padding-left: 10px;
    padding-right: 10px;
    .show-more {
        height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        cursor: pointer;
    }
    .folder-title {
        padding-top: 16px;
        font-size: 16px;
        font-weight: bold;
        .folder-count {
            font-size: 12px;
            color: #828282;
            font-weight: normal;
        }
    }
}
.zero-state {
    background-color: #ffffff;
}
.edited-by {
    color: #999;
    font-size: 12px;
    margin-left: 5px;
    cursor: pointer;
    white-space: nowrap;
}
.attach-file {
    background-color: #dfecf9;
    color: #2d3e4f;
}
.attach-file:hover {
    cursor: pointer;
}
.el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding-left: 0px;
}
.attach-name {
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    word-break: break-word;
    a {
        display: block;
        color: #2874e8;
        font-size: 12px;
        font-weight: 600;
        text-decoration: underline;
        text-decoration-color: #aecbf6;
    }
    a:hover {
        color: #2d3e4f;
    }
    a.downloading {
        opacity: 0.7 !important;
        color: #2874e8 !important;
        cursor: not-allowed;
    }
}
.attach-comment {
    p{
        font-size: 12px;
        line-height: 18px;
        word-break: break-word;
        margin-bottom: 4px;
    }
    .el-button {
        font-size: 10px;
        padding: 4px 8px;
        color: #2874e8;
        border: 1px solid #e2e2e2;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        .button-set {
            display: flex;
            line-height: 12px;
            svg, i {
                margin-right: 2px;
            }
        }
    }
}
.attach-uploader {
    font-size: 12px;
    line-height: 16px;
    color: #828282;
    text-align: right;
    word-break: break-word;
}
.display-row {
    display: flex;
    margin-bottom: 16px;
    .category-info {
        flex-grow: 1;
        .category-name {
            display: block;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            word-break: break-word;
        }
        .time {
            display: block;
            font-size: 12px;
            line-height: 18px;
            margin-top: 6px;
            color: #828282;
        }
    }
    .attach-file {
        min-width: 100px;
    }
}
.history-header {
    display: flex;
    align-items: center;
    .oval {
        height: 3px;
        width: 3px;
        margin-bottom: 2px;
        background-color: #666666;
        border-radius: 50%;
        margin-left: 8px;
        margin-right: 8px;
    }
    .name {
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin-left: 11px;  
    }
    .date {
        font-size: 14px;
        color: #666666;
    }
}
.history-comment {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    padding: 15px 0;
    word-break: break-word;
}
.record-history-body:not(:last-child) {
    border-bottom: 1px solid #e2e2e2;
}
.record-history-body {
    margin-top: 20px;
}
</style>

<style lang="scss">
@import './table-style.scss';
</style>